import { render, staticRenderFns } from "./SIAC.vue?vue&type=template&id=515dd6a1"
import script from "./SIAC.vue?vue&type=script&lang=js"
export * from "./SIAC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports